export default "__VITE_ASSET__c7858d8e__"